import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { BillingserviceService } from '../billingService.service';

@Component({
  selector: 'app-referred-by',
  templateUrl: './referred-by.component.html',
  styleUrls: ['./referred-by.component.scss']
})
export class ReferredByComponent implements OnInit {
  PersonType: any = null;
  PersonName: any = null;
  LocalAddress: any = null;
  mobnumber: any = null;
  refertype:any =[];
  constructor(public dialog: MatDialog, public billingservice: BillingserviceService,
    public dashboardService: DashboardService, public opdvisitService: OpdVisitService) { }

  ngOnInit(): void {
    this.refertype =[];
    this.refertype = [...new Map(this.opdvisitService.personmaster.map(item =>
      [item['personType'], item])).values()];
    // this.opdvisitService.referrebyid =  null;
  }

  checkrefferedbyVal(e) {
    this.opdvisitService.personmaster.forEach(item => {
      if (item.personName === this.PersonName) {
        this.dashboardService.openSnackBar("Referred By is already exist ", "OK");
        this.PersonName = ' '
      }
    });

  }

  onSubmitreferedBy() {
    if (this.PersonType != null &&
      this.PersonName != null &&
      this.mobnumber != null) {
      const insertdata = {
        "PkPersonId ": 0,
        "PersonType": this.PersonType,
        "PersonName": this.PersonName,
        "LocalAddress": this.LocalAddress,
        "MobileNo1": this.mobnumber
      }
      if (this.PersonName.length > 60) {
        this.dashboardService.openSnackBar("Referred By Name should be less then 60.", "OK");
      }
      else if (this.mobnumber.length < 10) {
        this.dashboardService.openSnackBar("Mobile number must be exactly 10 digits", "OK");
        return;
      }
      else if (this.LocalAddress.length > 250) {
        this.dashboardService.openSnackBar("Address should be less then 250.", "OK");
      } else {
        this.billingservice.addreferalName(insertdata).subscribe(resp => {
          if (resp.statusCode == "1") {
            this.opdvisitService.referrebyid = resp.id;
            this.opdvisitService.getpersonmaster('BILLING', 0);
            this.PersonType = null;
            this.PersonName = null;
            this.LocalAddress = null;
            this.mobnumber = null;
            this.dashboardService.openSnackBar("Record Saved Sucessfully", "OK");
          } else {
            this.dashboardService.openSnackBar(" API Failed ", "OK");
          }
          console.log('visitreferal add respone+=', resp);
          this.dialog.closeAll();
        });
      }
    } else {
      this.dashboardService.openSnackBar(" All * field are Mandatory ", "OK");
    }
  }

  closedialog() {
    this.dialog.closeAll();
  }
}
